'use client';

import { useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { DataRefreshProvider } from './data-refresh/data-refresh-provider';

export function ReactQueryProvider(props: React.PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            /*
             * Zero, not the usual minute. This is workspace data that several
             * people and the extraction pipeline all write to, and a minute of
             * held-back answers is what made a deleted order keep showing on
             * the dashboard until the page was reloaded by hand: the delete
             * happened on one screen, the dashboard was opened on another
             * inside the window, and the cached list was served without asking
             * the server.
             *
             * This does not mean a spinner on every navigation. React Query
             * still paints the cached answer instantly and refetches behind
             * it, so the screen is populated on arrival and correct a moment
             * later. Hooks that genuinely want a longer window (roles, the
             * account lookups) still set their own `staleTime`.
             */
            staleTime: 0,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <DataRefreshProvider>{props.children}</DataRefreshProvider>
    </QueryClientProvider>
  );
}
